import Stack from "@mui/material/Stack";
import BreadCrumbs from '../../../components/navbar/BreadCrumb';
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import CardActiveCorporate from "./CardActiveCorporate";
import { useEffect, useState } from "react";
import ErrorHandler from "../../../ErrorHandler";
import { activeCorporateList } from "../../../APIConfig/NewCorporateApiConfig";


// Active corporate list for user and white teamer
const ActiveCorporateList = ({ variant }) => {

    const [data, setData] = useState([]);
    const [load, setLoad] = useState(false);
    const { loading, userss, error } = useSelector((state) => state.user);
    console.log({ variant, loading, user_role: userss?.user_role }, 'active list page ')
    const breadcrumbs = [
        {
            name: "Dashboard",
            link: "/",
        },
        {
            name: "Active Scenarios",
        },
    ];


    useEffect(() => {
        setLoad(true);
        const getData = async () => {
            try {
                const response = await activeCorporateList();
                setData(response?.data)
            } catch (error) {
                ErrorHandler(error)
            } finally {
                setLoad(false);
            }
        }
        getData();
    }, [])


    return (
        <Stack>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading || load}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <BreadCrumbs breadcrumbs={breadcrumbs} />


            <Box style={{ width: "100%", padding: 40, }}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h2" padding={2}>
                        Active Scenarios
                    </Typography>
                </Stack>




                {data?.results?.length > 0 ? (

                    data?.results?.map((data) => (
                        console.log(data, 'datadata'),
                        <CardActiveCorporate
                            key={data?.id}
                            item={{
                                id: data?.id,
                                name: data?.scenario.name,
                                description: data?.scenario?.description,
                                severity_name: data?.scenario?.severity,
                                thumbnail_url: data?.scenario?.thumbnail_url,
                                points: data?.scenario?.points,
                                type_name: data?.scenario?.type,
                                ttx_enabled: data?.scenario?.ttx_enabled,
                                participant_id: data?.participant?.id,
                                VM_access: data?.participant?.has_vm_access,
                                ttx_access: data?.participant?.has_ttx_access,
                            }}
                        />
                    ))
                ) : (


                    <Stack justifyContent="center" alignItems="center">
                        <Typography variant="h3" sx={{ textAlign: "center", mt: "50px" }}>
                            No result found
                        </Typography>
                    </Stack>)
                }


            </Box>



        </Stack>
    );
}


export default ActiveCorporateList







